/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CardProgramOwner } from "./CardProgramOwner";
import {
  CardProgramOwnerFromJSON,
  CardProgramOwnerFromJSONTyped,
  CardProgramOwnerToJSON,
  CardProgramOwnerToJSONTyped,
} from "./CardProgramOwner";
import type { LoyaltyProgramEnum } from "./LoyaltyProgramEnum";
import {
  LoyaltyProgramEnumFromJSON,
  LoyaltyProgramEnumFromJSONTyped,
  LoyaltyProgramEnumToJSON,
  LoyaltyProgramEnumToJSONTyped,
} from "./LoyaltyProgramEnum";

/**
 * Authoritative issuer totals across the current user and active direct family peers, resolved separately per owner.
 * @export
 * @interface CardProgramSummary
 */
export interface CardProgramSummary {
  /**
   *
   * @type {LoyaltyProgramEnum}
   * @memberof CardProgramSummary
   */
  loyaltyProgram: LoyaltyProgramEnum;
  /**
   *
   * @type {string}
   * @memberof CardProgramSummary
   */
  cardInstitution: string;
  /**
   * Resolved issuer-currency balance. Zero is a known balance.
   * @type {number}
   * @memberof CardProgramSummary
   */
  loyaltyPoints: number;
  /**
   * Estimated value of issuer points; absent when valuation is unknown. Excludes cash back.
   * @type {number}
   * @memberof CardProgramSummary
   */
  cashValue?: number;
  /**
   *
   * @type {number}
   * @memberof CardProgramSummary
   */
  cashBackDollars?: number;
  /**
   * Number of distinct physical and manual cards, independent of the program balance.
   * @type {number}
   * @memberof CardProgramSummary
   */
  cardCount: number;
  /**
   *
   * @type {Array<CardProgramOwner>}
   * @memberof CardProgramSummary
   */
  owners: Array<CardProgramOwner>;
}

/**
 * Check if a given object implements the CardProgramSummary interface.
 */
export function instanceOfCardProgramSummary(
  value: object
): value is CardProgramSummary {
  if (!("loyaltyProgram" in value) || value["loyaltyProgram"] === undefined)
    return false;
  if (!("cardInstitution" in value) || value["cardInstitution"] === undefined)
    return false;
  if (!("loyaltyPoints" in value) || value["loyaltyPoints"] === undefined)
    return false;
  if (!("cardCount" in value) || value["cardCount"] === undefined) return false;
  if (!("owners" in value) || value["owners"] === undefined) return false;
  return true;
}

export function CardProgramSummaryFromJSON(json: any): CardProgramSummary {
  return CardProgramSummaryFromJSONTyped(json, false);
}

export function CardProgramSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CardProgramSummary {
  if (json == null) {
    return json;
  }
  return {
    loyaltyProgram: LoyaltyProgramEnumFromJSON(json["loyalty_program"]),
    cardInstitution: json["card_institution"],
    loyaltyPoints: json["loyalty_points"],
    cashValue: json["cash_value"] == null ? undefined : json["cash_value"],
    cashBackDollars:
      json["cash_back_dollars"] == null ? undefined : json["cash_back_dollars"],
    cardCount: json["card_count"],
    owners: (json["owners"] as Array<any>).map(CardProgramOwnerFromJSON),
  };
}

export function CardProgramSummaryToJSON(json: any): CardProgramSummary {
  return CardProgramSummaryToJSONTyped(json, false);
}

export function CardProgramSummaryToJSONTyped(
  value?: CardProgramSummary | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    loyalty_program: LoyaltyProgramEnumToJSON(value["loyaltyProgram"]),
    card_institution: value["cardInstitution"],
    loyalty_points: value["loyaltyPoints"],
    cash_value: value["cashValue"],
    cash_back_dollars: value["cashBackDollars"],
    card_count: value["cardCount"],
    owners: (value["owners"] as Array<any>).map(CardProgramOwnerToJSON),
  };
}
